// extracted by mini-css-extract-plugin
export default {"icon":"Facebook_icon__yY6oL","disabled":"Facebook_disabled__B6T7b"};